// generated by genversion
const version = '6.12.2';

export { version };
//# sourceMappingURL=version.mjs.map
